module.exports = __webpack_public_path__ + "img/small-3.95ac5459.webp";